export const moveToAnchor = (elem: HTMLElement, smooth?: boolean) => {
    const smoothProps = smooth ? { behavior: 'smooth' as ScrollBehavior } : {}
    if (elem) {
        window.scrollTo({
            top: elem.getBoundingClientRect().top + document.documentElement.scrollTop - 100,
            ...smoothProps,
        })
    }
}
